<template>
  <div class="wrap wrap-tec">
    <div class="banner con">
      <img src="@/assets/img/gene_factory/banner.png" class="img-fluid" alt="擎科基因工厂">
      <div class="info"></div>
    </div>
    <!---移动端-->
    <div class="banner cons" v-if="!$route.meta.invisible && !$route.meta.invisibles">
      <img src="@/assets/img/gene_factory/banner.png" class="img-fluid" alt="擎科基因工厂">
      <div class="info"></div>
    </div>
    <section>
      <div class="breads container" style="overflow:auto;line-height: 48px;padding-left: 10px;margin-bottom:  20px;">
        <bread></bread>
      </div>
      <div class="container container100">
        <p class="desc">
          生物技术基于基因检测、基因合成和基因编辑等三大技术模块来实现。在技术发展路径上，从底层模块到顶层模块，包括oligo合成和基因合成、基因组合成和最简基因组合成以及细胞工厂的构建。这些技术的发展离不开生产要素，如试剂、载体、设备和自动化，它们支撑着各项技术的进展。同时，寡核苷酸合成长度不断增加，产品和服务的应用也逐步拓展。
        </p>
        <p class="desc">
          随着生物经济和生物技术的发展，人们对基因合成提出了高效、快速、低成本的三大要求。因此，“基因工厂”成为未来发展的必然趋势。“基因工厂”是以基因合成要素中的合成原料、合成设备及合成工艺进行自动化自我聚集，搭建出合成要素的生产平台，实现稳定、高效、自主研发、自动化的基因合成智能生产系统。
        </p>
        <p class="desc">
          擎科生物作为“基因工厂”的提出者和践行者，通过搭建基因合成要素中原料、设备的生产平台、基因智能分子拆分及组装技术平台、智能AI算法平台螺旋桨系统（TSINGKE
          HELIXTECH），形成了合成要素自主的全产业链生产平台，实现稳定、高效、自主研发、自动化的基因合成智能生产，为客户提供基因合成、修饰合成、抗体蛋白、基因调控、基因检测、化学试剂、生物试剂、仪器设备和多种技术服务等。
        </p>
        <p class="desc">
          基因工厂生产的基因合成产品类型从300 bp到5
          kb甚至更长，广泛应用于各个领域，从科学研究到工业生产。例如，oligo合成主要应用于核酸药物领域，为扩大疾病治疗方法提供了新途径。基因合成涵盖核酸、氨基酸和蛋白质等多个领域的应用，广泛用于核酸疫苗、基因细胞疗法等方面。而基因组合成和最简基因组合成的应用，则包括生物育种、菌种改造以及代谢改造等领域的应用，将对未来食品和材料领域产生积极影响。
        </p>
        <div class="con"
          style="width: -moz-fit-content;width: fit-content; margin-top: 30px; text-align:center;">
          <img src="@/assets/img/gene_factory/main.png" style="width: 70%;">
        </div>
        <div class="cons gene_img">
          <img src="@/assets/img/gene_factory/main.png">
        </div>
      </div>
      <div class="service service1 container">
        <div class="c-title">产品及服务<small>Service and Products</small></div>
        <div class="title-desc">
          作为“基因工厂”的提出者和践行者，擎科生物运用智能化、工厂化思维，集合成原料、合成设备、合成工艺于一体，搭建智能化合成产线，在数字化管理系统的赋能下，可实现大规模、高效率、低成本生产制造基因，为客户提供寡核苷酸合成、寡核苷酸修饰、基因合成、基因检测、化学合成原材料、生物试剂、仪器设备、抗体蛋白、基因调控等多种服务和产品。
        </div>
        <!--合成基因组学产品及服务-->
        <ul class="service_chan">
          <li style="cursor: pointer" v-for="(item, index) in serviceIconList" :key="index"
            :class="{active: currentService === index}" @mouseover="currentService = index"
            @mouseout="currentService = -1" @click="$router.push(item.ref)">
            <div class="img">
              <img :src="`/static/img/fenzi_${index+1}${currentService === index ? '' : '_active'}.png`">
            </div>
            <p>{{ item.name }}</p>
            <div class="liaojie">了解更多></div>
          </li>
        </ul>
      </div>
      <div class="c-title">资源中心<small>Resource Center</small></div>
      <div class="container mt30 mb30">
        <ul class="download">
          <li v-for="item in resourcesLists" :key="item.id">
            {{item.name}}
            <el-button type="primary" class="mr41" icon="el-icon-download"
              v-if="item.resourceFile.fileType === 'PICTURE'"
              @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr41" icon="el-icon-download" @click="downFile(item)" v-else>下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download"
              v-if="item.resourceFile.fileType === 'PICTURE'"
              @click="bindDownLoad(item.resourceFile.visitedUrl, item.name)">下载</el-button>
            <el-button type="primary" class="mr42" size="mini" icon="el-icon-download" @click="downFile(item)"
              v-else>下载</el-button>
          </li>
        </ul>
      </div>
      <div class="container">
        <div class="c-title">相关研究领域<small>Related Research Fields</small></div>
        <div class="con">
          <ul class="xing_1">
            <li class="xingcheng1" @click="$router.push('/products/Products1')">
              <div class="img"><img src="@/assets/img/gene.png" width="100%" alt="擎科生物-合成基因组学产品及服务"></div>
              <p>合成基因组学产品及服务</p>
            </li>
            <li class="xingcheng2" @click="$router.push('/equipment/life_sciences')">
              <div class="img"><img src="@/assets/img/life.png" width="100%" alt="擎科生物-生命科学研究设备及原料"></div>
              <p>生命科学研究设备及原料</p>
            </li>
            <li class="xingcheng3" @click="$router.push('/Biological_manufacturing/Biological')">
              <div class="img"><img src="@/assets/img/biology.png" width="100%" alt="擎科生物-生物制造CXO"></div>
              <p>生物制造CXO</p>
            </li>
          </ul>
        </div>
        <div class="cons" style="margin-top: 20px; ">
          <ul class="xing_1">
            <li class="xingcheng1" @click="$router.push('/products/Products1')">
              <div class="img"><img src="@/assets/img/gene.png" width="100%" alt="擎科生物-合成基因组学产品及服务"></div>
              <p>合成基因组学产品及服务</p>
            </li>
            <li class="xingcheng2" @click="$router.push('/equipment/life_sciences')">
              <div class="img"><img src="@/assets/img/life.png" width="100%" alt="擎科生物-生命科学研究设备及原料"></div>
              <p>生命科学研究设备及原料</p>
            </li>
            <li class="xingcheng3" @click="$router.push('/Biological_manufacturing/Biological')">
              <div class="img"><img src="@/assets/img/biology.png" width="100%" alt="擎科生物-生物制造CXO"></div>
              <p>生物制造CXO</p>
            </li>
          </ul>
        </div>
      </div>
      <div class="container">
        <qk-consult type="Virus" />
      </div>
    </section>
  </div>
</template>
<script>
import { resourceColumns, resourceDownloads } from '@/services/api.index'
import bread from '@/components/bread'
export default {
  components: {
    bread
  },
  data() {
    return {
      currentService: -1,
      serviceIconList: [
        { name: '引物合成', ref: '/tec/compose1' },
        { name: '基因合成', ref: '/tec/gen_compose' },
        { name: '基因功能', ref: '/products/Gene_regulation' },
        { name: '病毒包装', ref: '/Virus/Virus_packaging' },
        { name: '常规分子项目', ref: '/products/Conventional_molecular_project' },
        { name: '基因检测', ref: '/products/Gene' }
      ],
      page: 0,
      total: 0,
      resourcesLists: [],
      categoryId: ''
    }
  },
  created() {
    this.getResourceColumns()
  },
  methods: {
    // 资源栏目
    getResourceColumns() {
      resourceColumns().then(res => {
        this.menuLists = res.data
        this.total = this.baseMethods.getTotal(res)
        this.getResourcesLists(res.data[0].id)
      })
    },
    // 根据栏目id获取资源列表
    getResourcesLists(id) {
      this.categoryId = id
      resourceDownloads(1, this.page, 20).then(res => {
        this.resourcesLists = res.data
        this.total = this.baseMethods.getTotal(res)
      })
    },
    // 下载
    bindDownLoad(imgsrc, name) {
      this.baseMethods.downloadImage(imgsrc, name)
    },
    downFile(item) {
      this.baseMethods.courseDownload(item.resourceFile.visitedUrl, item.name)
    }
  }
}
</script>
<style scoped lang="scss">
.strengths {
  display: flex;
  margin-top: 30px;
  li {
    flex: 1;
    text-align: center;
    border-right: 1px solid #eee;
    padding: 0 40px;
    &:last-child {
      border: 0;
    }
    h4 {
      font-size: 18px;
      margin-bottom: 10px;
      color: #014492;
    }
  }
}
.download {
  display: flex;
  flex-wrap: wrap;
  border-left: 1px solid #e4e6ea;
  li {
    width: 50%;
    padding: 20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #e4e6ea;
    border-right: 1px solid #e4e6ea;
    font-size: 16px;
    cursor: pointer;
    &:nth-of-type(1) {
      border-top: 1px solid #e4e6ea;
    }
    &:nth-of-type(2) {
      border-top: 1px solid #e4e6ea;
    }
    &:hover {
      color: #014492;
    }
  }
  .btn-primary {
    font-size: 14px;
    span {
      margin-right: 7px;
    }
  }
  .mr41 {
    display: block;
  }
  .mr42 {
    display: none;
  }
}
.table {
  tr {
    td:first-child {
      background: #f6fafd;
    }
  }
}
.c-title small {
  margin-top: 10px;
}
.desc {
  font-size: 16px;
}

.xing_1 {
  display: flex;
  overflow: auto;
  justify-content: space-between;
  flex-wrap: wrap;
  li {
    height: 312px;
    width: 380px;
    //margin-right: 30px;
    .img {
      width: 123px;
      padding-top: 43px;
      padding-bottom: 45px;
      margin-left: auto;
      margin-right: auto;
    }
    p {
      font-size: 20px;
      color: #fff;
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }
  }
  li:last-child {
    margin-right: 0;
  }
  .xingcheng1 {
    overflow: auto;
    background: url('../../assets/img/gene.jpg') no-repeat;
    background-size: auto;
  }
  .xingcheng2 {
    overflow: auto;
    background: url('../../assets/img/life.jpg') no-repeat;
    background-size: auto;
  }
  .xingcheng3 {
    overflow: auto;
    background: url('../../assets/img/biology.jpg') no-repeat;
    background-size: auto;
  }
  //鼠标移入后
  .xingcheng1:hover {
    overflow: auto;
    cursor: pointer;
    background: url('../../assets/img/gene1.jpg') no-repeat;
    background-size: auto;
  }
  .xingcheng2:hover {
    overflow: auto;
    cursor: pointer;
    background: url('../../assets/img/life1.jpg') no-repeat;
    background-size: auto;
  }
  .xingcheng3:hover {
    overflow: auto;
    cursor: pointer;
    background: url('../../assets/img/biology1.jpg') no-repeat;
    background-size: auto;
  }
}
.cons {
  display: none;
}
@media screen and (max-width: 375px) and (min-width: 374px),
  screen and (max-width: 414px) and (min-width: 413px),
  screen and (max-width: 640px) and (min-width: 600px),
  screen and (min-width: 300px) and (max-width: 400px) {
  .container100 {
    margin-bottom: 20px !important;
  }
  .cons .xing_1 {
    display: block !important;
    width: fit-content;
    margin-left: auto;
    margin-right: auto;
  }
  .cons .xing_1 li {
    margin-bottom: 10px;
    width: 320px !important;
    margin-right: 0 !important;
    height: 200px !important;
  }
  .cons .xing_1 li .img {
    width: 70px !important;
  }
  .cons .xing_1 li:last-child {
    margin-bottom: 0;
  }
  .cons .xing_1 li .img {
    padding-top: 35px !important;
    padding-bottom: 35px !important;
  }
  .cons .xing_1 .xingcheng1:hover {
    background: url('../../assets/img/life.jpg') no-repeat !important;
  }
  .cons .xing_1 .xingcheng2:hover {
    background: url('../../assets/img/biology.jpg') no-repeat !important;
  }
  .cons .xing_1 .xingcheng3:hover {
    background: url('../../assets/img/gene.jpg') no-repeat !important;
  }
}
.service1 {
  overflow: auto;
}

.service_chan {
  margin-bottom: 20px;
  display: flex;
  overflow: auto;
  flex-wrap: wrap;
  justify-content: space-between;

  li {
    width: 188px;
    height: 188px;
    //margin-right: 12px;
    background: url("../../assets/img/fuwu.jpg") no-repeat!important;
    background-size: auto!important;
    .img{
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      padding-top: 20px;
      padding-bottom: 20px;
    }

    p {
      font-size: 16px;
      color: #4e4e4e;
      margin-bottom: 10px;
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
    }

    .liaojie {
      width: -moz-fit-content;
      width: fit-content;
      margin-left: auto;
      margin-right: auto;
      color: #959595;
      cursor: pointer;
    }
  }
  li:hover{
    background: url("../../assets/img/fuwu1.jpg") no-repeat!important;
    background-size: auto!important;
    p{
      color: #fff;
    }

    .liaojie {
      color: #fff;
    }
  }

  li:last-child {
    margin-right: 0;
  }
}
</style>
<style scoped>
@import url('../../assets/sanger.css');
@import url('../../assets/service.css');
</style>



// WEBPACK FOOTER //
// src/views/gene-factory/index.vue